import styled from 'styled-components';
import { BodyBoldS } from '../../styles/globals';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin: 2.5rem 0 24px;
  border-radius: 6px;
  ${({ theme }) => `
    background: ${theme.colors.neutral.primary[5]};
    border: 1px solid ${theme.colors.neutral.primary[30]};
    padding: ${theme.layout.spacing.centy} ${theme.layout.spacing.centy} 20px;
  `};
`;

export const AddReminderButton = styled(BodyBoldS)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  cursor: pointer;
  margin-top: 2rem;
  margin-bottom: 1rem;
  color: #183a60;
`;
